export const OPEN_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP =
    'OPEN_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP';
export const CLOSE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP =
    'CLOSE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP';
export const DONE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP =
    'DONE_EDIT_PROMOTIONAL_BOXES_SECTION_POPUP';



// WEBPACK FOOTER //
// ./src/containers/builder/types/promotional_boxes_types.js